<div *ngIf="!isAd" class="player-options horizontal-focusable-container">
  <div *ngIf="showSubtitles" class="player-options-button focusable-element" tabindex="0"
  (click)="openSubtitlesMenu()" (focus)="focusOption(0)" (mouseover)="mouseEnterOptions($event, 0)">
    <app-icon name="subtitles"></app-icon>
    <p>{{ 'player.audio-subtitles' | translate }}</p>
  </div>
  <div *ngIf="isLive && !isLiveEvent" class="player-options-button focusable-element" tabindex="0"
  (click)="openEpg()" (focus)="focusOption(1)" (mouseover)="mouseEnterOptions($event, 0)">
    <app-icon name="epg"></app-icon>
    <p>{{ 'player.epg' | translate }}</p>
  </div>

  <!-- <div class="player-options-button focusable-element" tabindex="0"
  (click)="openQualityMenu()" (focus)="focusOption(showSubtitles ? 1 : 0)" (mouseover)="mouseEnterOptions($event, 1)">
    <app-icon name="quality"></app-icon>
    <p>{{ 'player.quality' | translate }}</p>
  </div> -->
  <div *ngIf="currentResource?.isSeries" class="player-options-button focusable-element" tabindex="0"
  (click)="suggestedNextClick()" (focus)="focusOption((isLive && !isLiveEvent) ? 2 : 1)" (mouseover)="mouseEnterOptions($event, 1)">
    <app-icon name="episodes"></app-icon>
    <p>{{ 'player.nextEpisode' | translate }}</p>
  </div>
</div>
